import { AddressVm } from "./AddressVm";

export class WorkshopVm{
    Id: number = 0;
    Cvr: string = "";
    Name: string = "";
    Address: AddressVm = new AddressVm();
    Phone: string = "";
    Responsible: string = "";
    AuthorizationNumber: string = "";

}